import React from 'react';

import ComplexDocumentDesign from '../ComplexDocumentDesign';
import { CONTEXT_KEYS } from '../../context/complexArtboardContext';

const OVERRIDE_ARTBOARD_STATE = { [CONTEXT_KEYS.IS_INTERACTIVE_DESIGN]: true };

export const InteractiveDocumentDesign = () => {
  return <ComplexDocumentDesign customState={OVERRIDE_ARTBOARD_STATE} />;
};

export default InteractiveDocumentDesign;
